function checkWindowWidth(fc1, fc2, fc3) {
	fc1 = fc1 || function() {};
	fc2 = fc2 || function() {};
	fc3 = fc3 || function() {};

	if (ww <= screenMob) {
		fc1();
	} else if (ww <= screenTab) {
		fc2();
	} else {
		fc3();
	}
}

const debounce = (func, delay) => {
	let inDebounce;
	return function() {
		const context = this;
		const args = arguments;
		clearTimeout(inDebounce);
		inDebounce = setTimeout(() => func.apply(context, args), delay);
	};
};

const isEmpty = (obj) => {
	for (var key in obj) {
		if (obj.hasOwnProperty(key)) return false;
	}
	return true;
};
